// extracted by mini-css-extract-plugin
export default {"switching":"O3pPzyeLLp1cC8w7ECDF","noneBorder":"YswIDttboPS8vvlLmj6X"};